import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/planning",
)({
  component: () => <Outlet />,
  beforeLoad: ({ context, matches }) => {
    context.planningStepper.onBeforeLoadStepRoute(Route.fullPath, matches);

    return {
      usePlanningStepper: () => {
        const { data: campaign } = useSuspenseQuery(
          context.campaignQueryOptions,
        );

        const stepperContext = context.useStepperContext(campaign);

        return context.planningStepper.useStepper({
          context: stepperContext,
        });
      },
    };
  },
});
